import { Wrapper } from './style';

function Component() {
	return (
		<Wrapper>
			<div className="container flex justify-between">
				<div className="img self-end">
					<img className="w-100" src="https://pay2mobile.fra1.digitaloceanspaces.com/aboutPayMobile-removebg-preview.png" alt="img" />
				</div>
				<div className="about-text self-center mb20">
					<h2 className="heading-2 fs-sm-20">
						About the <span className="strong">Pay2Mobile</span>
					</h2>
					<p className='fs-sm-12'>
						Recharging your mobile or paying your utility bill is easier than ever. A savings bank account or a wallet with Airtel Payments Bank is all that you need to pay your bills with
						just a tap.
					</p>
				</div>
			</div>
		</Wrapper>
	);
}

export default Component;
